module.exports = __webpack_public_path__ + "static/media/WiseUpImg.f7197c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/AppDevelopment/WiseUpImg.png
// module id = 462
// module chunks = 0